export default {
    BODY_FILL: "#FFFF",
    BODY_LINE: "0000",
    CLICK_NORMAL: "#f79696",
    CLICK_SELECTED: "#96F07A",
    QUESTION_MARK_FILL: "#FFFF"
};